import { useCenterIntakeProfile, useSaveCenterIntakeProfile } from "../../application/useIntakeProfile";
import { getPatientAge, type Patient } from "../../domain/Patient";
import IntakeProfileCard from "./IntakeProfileCard";

/**
 * The intake profile of a patient a centre holds, as its administrator reads
 * and corrects it: the values only. The suggestions come from the sessions,
 * which are not the centre's to read.
 */
export default function CenterPatientIntakeProfile({
    centerId,
    patientId,
    dateOfBirth,
    className,
}: {
    centerId: string;
    patientId: string;
    dateOfBirth?: string | null;
    className?: string;
}) {
    const profile = useCenterIntakeProfile(centerId, patientId);
    const save = useSaveCenterIntakeProfile(centerId, patientId);

    return (
        <IntakeProfileCard
            data={profile.data && { ...profile.data, suggestions: [], suggestions_available: false }}
            isLoading={profile.loading}
            isError={profile.failed}
            onRetry={profile.retry}
            onSave={(values) => save.mutateAsync(values)}
            isSaving={save.isPending}
            ageFromBirthDate={getPatientAge({ date_of_birth: dateOfBirth } as Patient)}
            headingLevel="h4"
            className={className}
        />
    );
}
